import { skipToken, useMutation, useQuery } from '@tanstack/react-query'

import { hydrateIdentity } from '@/lib/auth'

import { identityApi } from '../../api/identity-api'
import { identityKeys } from '../../api/query-keys'
import type { FederatedRoleMappingInput, SsoConfigInput } from '../../api/identity-api'

export function useSsoConfig(entityId: string | null) {
  return useQuery({
    queryKey: identityKeys.sso(entityId ?? ''),
    queryFn: entityId === null ? skipToken : () => identityApi.getSsoConfig(entityId),
  })
}

export function useSaveSsoConfig() {
  return useMutation({
    mutationFn: ({ entityId, input }: { entityId: string; input: SsoConfigInput }) =>
      identityApi.saveSsoConfig(entityId, input),
    meta: { invalidates: [['identity', 'sso']] },
  })
}

export function useFederatedRoleMappings(entityId: string | null) {
  return useQuery({
    queryKey: identityKeys.roleMappings(entityId ?? ''),
    queryFn: entityId === null
      ? skipToken
      : () => identityApi.getFederatedRoleMappings(entityId),
  })
}

export function useSaveFederatedRoleMappings() {
  return useMutation({
    mutationFn: ({
      entityId,
      mappings,
    }: {
      entityId: string
      mappings: FederatedRoleMappingInput[]
    }) => identityApi.saveFederatedRoleMappings(entityId, mappings),
    onSuccess: (_data, { entityId }) => hydrateIdentity(entityId),
    meta: { invalidates: [['identity', 'sso-role-mappings']] },
  })
}
